export default "/images/4eb5f88a2f8b807b9bc9014a45b97720.avif";